export const VALUABLES = [
  {
    name: "valuablesWithinTheHome",
    title: "Item details",
    textLinkToOpenPopup: "What's included?",
    description:
      "If you have already specified an item to be covered away from the home, it does not need to be included here.",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Precious metals",
          value: "PreciousMetals",
        },
        {
          text: "Precious stones",
          value: "PreciousStones",
        },
        {
          text: "Jewellery/Watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Works of art",
          value: "WorksOfArt",
        },
        {
          text: "Computer equipment",
          value: "ComputerEquipment",
        },
        {
          text: "Portable electrical equipment",
          value: "PortableElectricalEquipment",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "Specified",
    items: [],
    modalData: {
      showLink: true,
      ref: "showWhatsIncludedValuablesInHome",
      title:
        "Do you have any valuables worth more than £2,500 within the home?",
      helpDialogTitle: "Valuables",
    },
  },
];

export const VALUABLES_TENANT = [
  {
    name: "valuablesWithinTheHome",
    title: "Item details",
    textLinkToOpenPopup: "What's included?",
    description:
      "If you have already specified an item to be covered away from the home, it does not need to be included here.",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Precious Metals or Stones",
          value: "PreciousMetalsOrStones",
        },
        {
          text: "Jewellery/Watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Works of art",
          value: "WorksOfArt",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "Specified",
    items: [],
    modalData: {
      showLink: true,
      ref: "showWhatsIncludedValuablesInTenantsContents",
      title:
        "Do you have any valuables worth more than £2,500 within the home?",
      helpDialogTitle: "Valuables",
    },
  },
];

export const VALUABLES_D2C = [
  {
    name: "valuablesWithinTheHome",
    title: "Item type",
    mainTitle: "Valuable items",
    imageName: "valuable-items.png",
    description:
      "Valuable items worth more than £2,500 and kept in the home must be specified. Any valuables which cost less than £2,500 are covered as standard.",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Precious metals",
          value: "PreciousMetals",
        },
        {
          text: "Precious stones",
          value: "PreciousStones",
        },
        {
          text: "Jewellery/Watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Works of art",
          value: "WorksOfArt",
        },
        {
          text: "Computer equipment",
          value: "ComputerEquipment",
        },
        {
          text: "Portable electrical equipment",
          value: "PortableElectricalEquipment",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "Specified",
    items: [],
    modalData: {
      showLink: true,
      dialogComponentName: "DialogContentWhatIsAValuableItem",
      title: "Valuables",
    },
  },
];
